import Vue from 'vue';
import Router from 'vue-router';
import Addresses from '@/components/CheckOut/Addresses';
import Basket from '@/components/CheckOut/Basket';
import BrandsThatTrustUs from '@/components/StaticPages/BrandsThatTrustUs';
import BulkOrder from '@/components/StaticPages/BulkOrder';
import CheckOut from '@/components/CheckOut/CheckOut';
import ContactUs from '@/components/Contact/Contact';
import ContactThankYou from '@/components/Contact/ContactThankYou';
import Customisation from '@/components/StaticPages/Customisation';
import Delivery from '@/components/StaticPages/Delivery';
import Design from '@/components/Order/Design';
import Dtg from '@/components/StaticPages/Dtg';
import Embroidery from '@/components/StaticPages/Embroidery';
import Finishing from '@/components/StaticPages/GarmentFinishing';
import Garment from '@/components/Garments/Garments';
import FilterGarment from '@/components/Garments/FilterGarments';
import Home from '@/components/Home/Home';
import HowToOrder from '@/components/StaticPages/HowToOrder';
import Login from '@/components/Auth/GetToken';
import LoyaltyScheme from '@/components/StaticPages/LoyaltyScheme';
import MyDesigns from '@/components/Profile/MyDesigns';
import MyFavourites from '@/components/Profile/MyFavourites';
import MyOrders from '@/components/Profile/MyOrders';
import MyProfile from '@/components/Profile/MyProfile';
import Order from '@/components/Order/Order';
import OrganicSustainable from '@/components/StaticPages/OrganicSustainable';
import Payment from '@/components/CheckOut/Payment';
import Preview from '@/components/CheckOut/Preview';
import PriceGuide from '@/components/StaticPages/PriceGuide';
import Profile from '@/components/Profile/Profile';
import Screenprinting from '@/components/StaticPages/Screenprinting';
import Sectors from '@/components/Garments/Sectors';
import SingleGarment from '@/components/Garments/SingleGarment';
import SiteMap from '@/components/StaticPages/Sitemap';
import Thankyou from '@/components/CheckOut/Thankyou';
import Uploader from '@/components/Uploader/Uploader';
import ViewDesign from '@/components/Profile/ViewDesign';
import Welcome from '@/components/StaticPages/Welcome';
import WhyChooseUs from '@/components/StaticPages/WhyChooseUs';
import Workwear from '@/components/StaticPages/Workwear';
import store from '../store/index';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        { path: '/garments/drawstringgymbags', redirect: '/garments/gymbags' },
        { path: '/garments/totebags', redirect: '/garments/tote-bags' },
        { path: '/garments/hvjackets', redirect: '/garments/hi-vis-jackets' },
        { path: '/garments/hvvests', redirect: '/garments/hi-vis-vests' },
        { path: '/garments/hvtrousers', redirect: '/garments/hi-vis-trousers' },
        { path: '/garments/hvtspolos', redirect: '/garments/hi-vis-tshirts' },
        { path: '/garments/lsshirts', redirect: '/garments/long-sleeve-shirts' },
        { path: '/garments/lspoloshirts', redirect: '/garments/long-sleeve-polo-shirts' },
        { path: '/garments/lstshirts', redirect: '/garments/long-sleeve-tshirts' },
        {
            path: '/screenprinting',
            redirect: '/screen-printing',
        },
        {
            path: '/',
            name: 'Home',
            component: Home,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/brands-that-trust-us',
            name: 'BrandsThatTrustUs',
            component: BrandsThatTrustUs,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/bulk-order',
            name: 'BulkOrder',
            component: BulkOrder,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/contact-us',
            name: 'ContactUs',
            component: ContactUs,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/contact-thankyou',
            name: 'ContactThankYou',
            component: ContactThankYou,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/checkout',
            name: 'CheckOut',
            component: CheckOut,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
            children: [
                {
                    path: 'basket',
                    name: 'Basket',
                    component: Basket,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
                {
                    path: 'addresses',
                    name: 'Addresses',
                    component: Addresses,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
                {
                    path: 'payment',
                    name: 'Payment',
                    component: Payment,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
                {
                    path: 'thankyou',
                    name: 'Thankyou',
                    component: Thankyou,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
            ],
        },
        {
            path: '/customisation',
            name: 'Customisation',
            component: Customisation,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/delivery',
            name: 'Delivery',
            component: Delivery,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/direct-to-garment-printing',
            name: 'DTG',
            component: Dtg,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/embroidery-service',
            name: 'Embroidery',
            component: Embroidery,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/garment-finishing-relabeling',
            name: 'Finishing',
            component: Finishing,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/garments',
            name: 'Garments',
            component: Garment,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
            children: [
                {
                    path: ':type/:gender?',
                    name: 'FilterGarments',
                    component: FilterGarment,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
            ],
        },
        {
            path: '/sectors/:sector',
            name: 'Sectors',
            component: Sectors,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/how-to-order',
            name: 'HowToOrder',
            component: HowToOrder,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/loyalty-scheme',
            name: 'LoyaltyScheme',
            component: LoyaltyScheme,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/order',
            name: 'Order',
            component: Order,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
            children: [
                {
                    path: 'upload-artwork',
                    name: 'UploadArtwork',
                    component: Uploader,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
                {
                    path: 'design',
                    name: 'Design',
                    component: Design,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
            ],
        },
        {
            path: '/organic-sustainable',
            name: 'OrganicSustainable',
            component: OrganicSustainable,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/preview/:id',
            name: 'Preview',
            component: Preview,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/price-guide',
            name: 'PriceGuide',
            component: PriceGuide,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
            children: [
                {
                    path: 'my-profile',
                    name: 'MyProfile',
                    component: MyProfile,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
                {
                    path: 'my-orders',
                    name: 'MyOrders',
                    component: MyOrders,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
                {
                    path: 'my-designs',
                    name: 'MyDesigns',
                    component: MyDesigns,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
                {
                    path: 'my-favourites',
                    name: 'MyFavourites',
                    component: MyFavourites,
                    beforeEnter(to, from, next) {
                        const direction = 'close';
                        store.dispatch('toggleNav', { direction });
                        next();
                    },
                },
            ],
        },
        {
            path: '/:category/:id/:name',
            name: 'SingleGarment',
            component: SingleGarment,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/screen-printing',
            name: 'Screenprinting',
            component: Screenprinting,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/sitemap',
            name: 'Sitemap',
            component: SiteMap,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/uploader',
            name: 'Uploader',
            component: Uploader,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/view-design/:id',
            name: 'ViewDesign',
            component: ViewDesign,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/welcome',
            name: 'Welcome',
            component: Welcome,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/why-choose-us',
            name: 'WhyChooseUs',
            component: WhyChooseUs,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
        {
            path: '/workwear',
            name: 'Workwear',
            component: Workwear,
            beforeEnter(to, from, next) {
                const direction = 'close';
                store.dispatch('toggleNav', { direction });
                next();
            },
        },
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js